// extracted by mini-css-extract-plugin
export default {"BurgerButton":"styles_BurgerButton__AsaSV","open":"styles_open__P2CHf"};